import { ca } from '@cian/analytics';
import { getCustomUrl } from '../../utils/analytics';

export function trackClickLink(id: number, name: string, position: number) {
  ca('eventSite', {
    action: 'Click',
    category: 'CountryBuilders',
    label: 'site_country_builders',
    name: 'oldevent',
    products: [
      {
        id,
        extra: { name },
        offerType: 'CountryBuilder',
        position,
      },
    ],
  });
}

export function trackClickPhone(id: number, name: string, position: number) {
  ca('eventSite', {
    action: 'Open_listing_cb',
    category: 'Phones',
    label: getCustomUrl(id),
    name: 'oldevent',
    products: [
      {
        id,
        extra: { name },
        offerType: 'CountryBuilder',
        position,
      },
    ],
  });
}

export function trackClickCall(id: number, name: string, position: number) {
  ca('eventSite', {
    action: 'Call_listing_cb',
    category: 'Phones',
    label: getCustomUrl(id),
    name: 'oldevent',
    products: [
      {
        id,
        extra: { name },
        offerType: 'CountryBuilder',
        position,
      },
    ],
  });
}
